import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetAgencyDesignChoicesQuery,
  GetAgencyDesignsDocument,
  GetAgencyDesignsQuery,
  GetAgencyDesignsQueryVariables
} from '~/api/graphql';

// Used by the document picker and the export summary of template and Design pages.
export type AgencyDesignChoices = NonNullable<GetAgencyDesignChoicesQuery['agency']>;

export const getAgencyDesigns = async () =>
  queryData<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables, GetAgencyDesignsQuery>(
    client,
    { query: GetAgencyDesignsDocument },
    (data) => data
  );

// The route also guards on the Styles permission, which a field error here would otherwise
// pre-empt with an error page.
export const loadAgencyDesigns: LoaderFunction = () =>
  loadQuery(getAgencyDesigns(), { suppressAuthErrors: true });
